import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

interface Props {
  color?: string;
}

const RightRow = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
`;
const Status = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  align-items: flex-start;
  border-top: 0.5px solid var(--border-primary);
  padding-top: var(--space-12);
`;

const StatusRow = styled.div`
  ${FlexBetween}
  padding: var(--space-6) var(--space-8);
  width: -webkit-fill-available;
  gap: var(--space-10);
  .active-state {
    border-radius: var(--border-radius-6);
    background-color: var(--background-muted);
  }
`;
const StatusRow1 = styled.div`
  ${FlexBetween}
  padding: var(--space-6) var(--space-8);
`;

const CircleIcon = styled.div<Props>`
  margin: var(--space-4);
  width: 8px;
  height: 8px;
  border-radius: var(--border-radius-full);
  ${(props: Props) =>
    props.color &&
    css`
      background-color: ${props.color};
    `}
`;
const LabelGroup = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  cursor: pointer;
  p {
    ${Typography.body_md_medium}
    color: var(--text-secondary);
    margin: var(--space-0);
    cursor: pointer;
  }
`;

export { RightRow, StatusRow, Status, StatusRow1, CircleIcon, LabelGroup };
